import { useEffect, useRef } from "react";
import styles from "./YouTubeModal.module.scss";
import { RefInt, YouTubeModalInt } from "interfaces";

const YouTubeModal = ({ href, open, closeModal }: YouTubeModalInt) => {
  const onCloseRef: RefInt = useRef(null);

  useEffect(() => {
    function handleClickOutside(event: any) {
      if (onCloseRef.current && !onCloseRef.current.contains(event.target)) {
        closeModal();
      }
    }
    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
      document.addEventListener("scroll", handleClickOutside);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("scroll", handleClickOutside);
    };
  }, [open]);

  return open ? (
    <div className={styles.modal}>
      <div className={styles.video}>
        <div ref={onCloseRef} className={styles["video-wrapper"]}>
          <div className={styles.placeholder}>
            <h2>VIDEO LOADING</h2>
            <h5>Please wait...</h5>
          </div>
          <iframe
            // loading="lazy"
            width="800"
            height="500"
            src={href}
            title="YouTube video player"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <button
          className={styles.close}
          aria-label="close video modal"
          onClick={() => closeModal()}
        />
      </div>
    </div>
  ) : null;
};

export default YouTubeModal;
